import { openDB, DBSchema } from 'idb'

const storeName = 'places'

interface Place {
  fetchedOn: Date
  photos: PlacePhoto[]
}

interface PlacePhoto {
  height: number
  width: number
  url: string
}

interface PlacesDB extends DBSchema {
  places: {
    value: Place
    key: string
    indexes: { byFetchedOn: Date }
  }
}

const getDb = () => {
  if (typeof window === 'undefined') return undefined
  const dbPromise = openDB<PlacesDB>(`${storeName}-store`, 1, {
    async upgrade(db) {
      const placesStore = db.createObjectStore(storeName)
      placesStore.createIndex('byFetchedOn', 'fetchedOn')
    },
  })

  return {
    get: async function (key: string) {
      return (await dbPromise).get(storeName, key)
    },
    set: async function (key: string, place: Place) {
      return (await dbPromise).put(storeName, place, key)
    },
    del: async function (key: string) {
      return (await dbPromise).delete(storeName, key)
    },
    clear: async function () {
      return (await dbPromise).clear(storeName)
    },
    keys: async function () {
      return (await dbPromise).getAllKeys(storeName)
    },
  }
}
export default getDb
